import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { qualityKeys } from '@/shared/lib/query/queryKeys';

import { getQualityTrend, type QualityTrendApiParams } from '@/entities/quality/api/getQualityTrend';

export const useQualityTrendQuery = (params: QualityTrendApiParams) => {
  return useQueryWithBoundary({
    queryKey: qualityKeys.qualityTrend(params),
    queryFn: () => getQualityTrend(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
